import { z } from 'zod'

export const ContactSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  phone: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
  companyRole: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
  notes: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
  customerId: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
  organizationId: z
    .string()
    .nullish()
    .transform((data) => data ?? ''),
})

export type Contact = z.infer<typeof ContactSchema>
export const ContactsSchema = z.array(ContactSchema)

export type Contacts = z.infer<typeof ContactsSchema>

export const ContactRequestSchema = ContactSchema.omit({ id: true })
export type ContactRequest = z.infer<typeof ContactRequestSchema>
